// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2665":"ebe0e953","3932":"ebe0e953","4489":"6ef5af8b","8143":"df3ca7a3"}[chunkId] + ".chunk.css";
};